export const elementInfoClasses = theme => ({
    elementInfoRoot: {
        display: 'flex',
        marginBottom: theme.spacing(6),

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    elementInfoImageContainer: {
        flex: '1 1 50%',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
    },
    elementInfoImage: {
        width: '100%',
    },
    elementInfoDescriptionContainer: {
        flex: '1 1 50%',
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
    },
    elementInfoTitle: {
        flex: '1 1 auto',
        margin: theme.spacing(1),
    },
    elementInfoProgress: {
        height: 12,
        marginTop: theme.spacing(2),
    },
    elementInfoProgressText: {
        marginTop: theme.spacing(0.5),
    },
    elementInfoDescription: {
        margin: theme.spacing(1),
    },
});


export const tableListClasses = theme => ({
    tableListRoot: {
        boxShadow: theme.shadows[1],

        [theme.breakpoints.down('xs')]: {
            boxShadow: 'none',
        },
    },
    tableListTitleContainer: {
        padding: theme.spacing(1, 8),
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        border: theme.youwell.borders.dim,
        borderWidth: '0px 1px',

        [theme.breakpoints.down('xs')]: {
            borderWidth: 0,
            background: theme.palette.grey[100],
            color: theme.palette.primary.main,
            padding: theme.spacing(1, 4),
        },
    },
    tableListTitle: {

    },
    tableListRows: {
        display: 'flex',
        flexDirection: 'column',

        [theme.breakpoints.down('xs')]: {
            flex: '1 1 auto',
        },
    },
    tableListRow: {
        display: 'flex',
    },
    tableListRowIndex: {
        background: theme.palette.secondary.main,
        borderBottom: theme.youwell.borders.dim,
        width: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.common.white,

        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(4),
        },
    },
    tableListRowElement: {
        flex: '1 1 0px',
        margin: theme.spacing(0, 4),
        padding: theme.spacing(2, 0),
        borderBottom: theme.youwell.borders.dim,
        color: theme.palette.grey[400],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',

        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(0, 2),
        },

        '$tableListCurrent &': {
            background: theme.palette.grey[200],
            color: theme.palette.common.black,
            margin: '-1px 0 0',
            padding: theme.spacing(2, 4),

            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(2),
            },
        },
        '$tableListCompleted &': {
            color: theme.palette.common.black,
        },
        '$tableListUnavailable &': {
            color: theme.palette.grey[400],
        },
    },
    tableListRowElementTitle: {
        flex: '1 1 auto',
    },
    tableListCurrent: {
    },
    tableListCompleted: {
    },
    tableListUnavailable: {
    },
});

export const iconClasses = theme => ({
    iconGreen: {
        color: theme.youwell.colors.green,
        opacity: 0.5,
    },
    iconRed: {
        color: theme.youwell.colors.red,
        opacity: 0.7,
    },
    iconGray: {
        color: theme.palette.grey[400],
        opacity: 0.7,
    },
});
